<template>
   <div class="gridMe" v-if="active">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
   </div>
</template>

<script setup lang="ts">
const active = ref<boolean>(false);

const toggle = (event: KeyboardEvent) => {
   if (event.key === "|") {
      active.value = !active.value;
   }
};

onMounted(() => {
   document.addEventListener("keydown", toggle);
});

onBeforeUnmount(() => {
   document.removeEventListener("keydown", toggle);
});
</script>
